import { formValueSelector } from 'redux-form/immutable';
import fieldsConfig from 'modules/Taps/components/PersonalInfoGP3/fieldsConfig';

export const SimplifiedDeductionFormSteps = ((prefix) => {
  return {
    step1: `${prefix}_step1`,
    step2: `${prefix}_step2`,
    step3: `${prefix}_step3`,
  };
})('SimplifiedDeduction');

export const SimplifiedDeductionFormSelectors = {
  step1: formValueSelector(SimplifiedDeductionFormSteps.step1),
  step2: formValueSelector(SimplifiedDeductionFormSteps.step2),
};

export const personalDataFields = [
  fieldsConfig.inn,
  fieldsConfig.lastName,
  fieldsConfig.firstName,
  fieldsConfig.middleName,
  fieldsConfig.dateOfBirth,
  fieldsConfig.placeOfBirth,
  fieldsConfig.address,
  fieldsConfig.documentTypes,
  fieldsConfig.documentNumber,
  fieldsConfig.documentDate,
  fieldsConfig.issuedBy,
];
